import React from 'react';
import Hero from "./components/prog-offered-courses/Hero";
import Main from "./components/prog-offered-courses/Main";

const ProgOfferedCourses = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default ProgOfferedCourses;